const initialState = {
    isAuthenticated: false,
}

const AuthenticationReduser = (state = initialState, action) => {
    switch (action.type) {
        case 'AUTHORIZE':
            return (initialState.isAuthenticated = action.payload)

        default:
            return state
    }
}

export default AuthenticationReduser
